export const APP_IDENTIFIER = 'timeline-settings';
export const APP_TEAM_NAME = 'a4t-pandora';
export const APP_SOURCE_NAME = 'timelineSettings';
export const APP_BOUNDARY_ID = 'jira.board-settings.cmp.timeline';

export const APP_CMP_METRIC_KEY = `software.cmp.boards.${APP_IDENTIFIER}`;

export const BOARD_SETTINGS_TIMELINE_UFO_NAME = 'board-settings.timeline';
